/* eslint react-hooks/rules-of-hooks: "warn" */
import { useFramework } from '@/framework';
import { GroupRoleType, IGroupLayerProps, LayerType, type ILayerProps } from '@/version-types';
import { type HierarchyMenuItem } from './types';

/**
 * 图层缩略图尺寸
 */
export const THUMBNAIL_SIZE = 40;

/**
 * UI 常量: 普通图层 item 高度
 */
export const ITEM_HEIGHT = 56;

/**
 * UI 常量: 图层 item 底部间距
 */
export const ITEM_MARGIN_BOTTOM_NORMAL = 8;

/**
 * UI 常量: 组图层 item 底部间距
 */
export const ITEM_MARGIN_BOTTOM_GROUPED = 12;

/**
 * UI 常量: 滚动区域最大高度
 */
export const SCROLL_AREA_MAX_HEIGHT = 436;

/**
 * UI 常量: 组图层 item 底部装饰高度
 */
export const GROUP_ITEM_BOTTOM_DECORATION_HEIGHT = 4;

/**
 * 事件集合
 */
export const HIERARCHY_EVENTS = {
    OPEN: 'hierarchy/open',
    LAYER_OPERATION: 'hierarchy/layer-operation',
    SELECT_MANUAL: 'hierarchy/select-manual',
    TOGGLE_AVAILABILITY: 'hierarchy/toggle-availability',
};

export const DEFAULT_PREVENT_HIDDEN_TYPES = [LayerType.BACKGROUND_LAYER, LayerType.MAIN_LAYER];

const checkIsPuzzle = (layer: ILayerProps) => {
    const framework = useFramework();
    const parentId = layer.parentId;
    if (!parentId) return false;
    const parentLayer = framework.getLayer(parentId);

    if (!parentLayer) return false;
    return (
        parentLayer.layerType === LayerType.GROUP_LAYER &&
        (parentLayer.data as IGroupLayerProps).extension?.role === GroupRoleType.PUZZLE
    );
};

const defaultPredicate = (layer: ILayerProps) => {
    if (DEFAULT_PREVENT_HIDDEN_TYPES.includes(layer.layerType)) return false;
    if (checkIsPuzzle(layer)) return false;
    return !layer.lock;
};

const getDefaultHierarchyMenus = () => {
    const deleteItem: HierarchyMenuItem = {
        icon: 'TrashCan',
        labelKeyPath: 'plugin.hierarchy.delete', // Q: 这里为什么不直接用 $t(v => v.plugin.hierarchy.delete)？ A: 不能保证编辑器启动前 i18n 已经加载完成
        operation: 'delete',
        predicate: defaultPredicate,
    };

    const duplicateItem: HierarchyMenuItem = {
        icon: 'Duplicate',
        labelKeyPath: 'plugin.hierarchy.duplicate',
        operation: 'duplicate',
        predicate: (layer: ILayerProps) => {
            if (layer.layerType === LayerType.WATERMARK) return false;
            return defaultPredicate(layer);
        },
    };

    return [deleteItem, duplicateItem];
};

export const getDefaultHierarchyConfig = () => {
    return {
        onlyShowSortableLayers: false,
        menuItems: getDefaultHierarchyMenus(),
        preventHiddenTypes: DEFAULT_PREVENT_HIDDEN_TYPES,
    };
};
